import React from 'react';

/**
 * Pickatale Phonics design-system icons.
 *
 * Ported verbatim from the v2 design-system handoff (`react/icons.js`). Every
 * glyph is drawn on a 24×24 grid with a 2px stroke and inherits `currentColor`,
 * so set the colour on the parent (or via `className`) rather than hardcoding.
 */
export const ICONS = {
  academy:
    '<path d="M12 4 2 9l10 5 10-5-10-5Z"/><path d="M5 11v4c0 1.5 3 3 7 3s7-1.5 7-3v-4"/><path d="M22 9v5"/>',
  appearance:
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>',
  arrowLeft: '<path d="M19 12H5"/><path d="m11 6-6 6 6 6"/>',
  arrowRight: '<path d="M5 12h14"/><path d="m13 6 6 6-6 6"/>',
  assessment:
    '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="m9 10 2 2 4-4"/><path d="M9 16h6"/>',
  audio:
    '<path d="M4 9v6h4l5 4V5L8 9H4Z"/><path d="M16.5 8.5a5 5 0 0 1 0 7"/><path d="M19 6a8 8 0 0 1 0 12"/>',
  bookCreator:
    '<path d="M3 5a2 2 0 0 1 2-2h6v17H5a2 2 0 0 0-2 2V5Z"/><path d="M21 5a2 2 0 0 0-2-2h-6v17h6a2 2 0 0 1 2 2V5Z"/>',
  calendar:
    '<rect x="3" y="4.5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 2.5v4M16 2.5v4"/>',
  check: '<path d="M5 12l4 4L19 7"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  download: '<path d="M12 4v10m0 0 4-4m-4 4-4-4"/><path d="M5 19h14"/>',
  lock: '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  star: '<path d="M12 3l2.6 5.3 5.9.9-4.2 4.1 1 5.8L12 16.8 6.7 19.2l1-5.8-4.2-4.1 5.9-.9L12 3Z"/>',
  chevronDown: '<path d="m6 9 6 6 6-6"/>',
  chevronRight: '<path d="m9 6 6 6-6 6"/>',
  classes:
    '<path d="M12 2 3 7v6c0 5 3.8 8 9 9 5.2-1 9-4 9-9V7l-9-5Z"/><path d="m9 12 2 2 4-4"/>',
  completion:
    '<circle cx="12" cy="12" r="8"/><path d="M12 12V4a8 8 0 0 0-6.9 12"/>',
  dashboard:
    '<rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/>',
  decodable:
    '<path d="M4 5a2 2 0 0 1 2-2h11v16H6a2 2 0 0 0-2 2Z"/><path d="M17 3v16"/><path d="M8 7h5"/>',
  filter: '<path d="M3 5h18l-7 8v5l-4 2v-7L3 5Z"/>',
  guide:
    '<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/>',
  lessons:
    '<path d="M4 4h13a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H4Z"/><path d="M8 8h7M8 12h7"/>',
  library:
    '<path d="M4 4h4v16H4zM10 4h4v16h-4z"/><path d="M16.5 4.8l3.4.9-3.1 14.4-3.4-.9"/>',
  logout:
    '<path d="M14 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><path d="M9 16l-4-4 4-4"/><path d="M5 12h11"/>',
  menu: '<path d="M4 6h16M4 12h16M4 18h16"/>',
  openBook:
    '<path d="M3 6c2.5-1 6-1 9 1 3-2 6.5-2 9-1v13c-2.5-1-6-1-9 1-3-2-6.5-2-9-1V6Z"/><path d="M12 7v13"/>',
  overview:
    '<path d="M8 6h12M8 12h12M8 18h12"/><circle cx="4" cy="6" r="1"/><circle cx="4" cy="12" r="1"/><circle cx="4" cy="18" r="1"/>',
  phoneme:
    '<path d="M4 5h16a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"/><path d="M8 10.5v1M11 9v4M14 8v6M17 10.5v1" stroke-width="1.8"/>',
  play: '<circle cx="12" cy="12" r="9"/><path d="M10 8.5v7l5.5-3.5-5.5-3.5Z" fill="currentColor" stroke="none"/>',
  preview:
    '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>',
  reading:
    '<path d="M3 5c2.2-.8 5.3-.8 8 1v13c-2.7-1.8-5.8-1.8-8-1Z"/><path d="M21 5c-1.4-.5-3.2-.6-4.8-.2"/><path d="M13 7v12c2.7-1.8 5.8-1.8 8-1V9"/><path d="M16.5 6.5l2 2M19.5 6l1.2 1.2" stroke-width="1.6"/>',
  scoreRing:
    '<circle cx="12" cy="12" r="8"/><path d="M12 4a8 8 0 0 1 7 4" stroke-opacity="1"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
  sort: '<path d="M7 4v16"/><path d="m3 8 4-4 4 4"/><path d="M17 20V4"/><path d="m13 16 4 4 4-4"/>',
  spelling: '<path d="M4 20l1-4L16 5l3 3L8 19l-4 1Z"/><path d="M14 7l3 3"/>',
  statistics:
    '<path d="M4 20V10"/><path d="M10 20V4"/><path d="M16 20v-7"/><path d="M22 20H2"/>',
  students:
    '<circle cx="9" cy="8" r="3.2"/><path d="M3.5 19a5.5 5.5 0 0 1 11 0"/><path d="M16 5.5a3.2 3.2 0 0 1 0 6.3"/><path d="M17 13.5a5.5 5.5 0 0 1 3.5 5.1"/>',
  training:
    '<path d="M12 4 2 9l10 5 10-5-10-5Z"/><path d="M6 11v4c0 1.4 2.7 2.6 6 2.6s6-1.2 6-2.6v-4"/>',
  usersCount:
    '<circle cx="12" cy="8" r="3.4"/><path d="M5.5 19a6.5 6.5 0 0 1 13 0"/>',
} as const;

export type IconName = keyof typeof ICONS;

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  title?: string;
}

export const Icon = ({ name, size = 24, className, title }: IconProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    role={title ? 'img' : 'presentation'}
    aria-hidden={title ? undefined : true}
    aria-label={title}
    dangerouslySetInnerHTML={{
      __html: (title ? `<title>${title}</title>` : '') + ICONS[name],
    }}
  />
);
